import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";

import MDTypography from "../../../components/MDTypography";
import MDBox from "../../../components/MDBox";

function BundleList({bundleData, updateIndex, selectedIndex}) {
    return (
        <MDBox sx={{alignItems: "stretch"}}>
            <Paper sx={{m: 1, p: 2}}>
                <MDTypography variant="h4">
                    Bundles
                </MDTypography>
            </Paper>
            <Paper sx={{py: 1, px:1}}>
                <TableContainer sx={{ maxHeight: "calc(100vh * .75)"}}>
                    <Table stickyHeader>
                        <TableHead sx={{ display: "table-header-group" }}>
                            <TableRow>
                                <TableCell>Bundle</TableCell>
                                <TableCell>Asset Count</TableCell>
                                <TableCell>Score</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {bundleData.map((item, index) => (
                                <TableRow 
                                    key={index} 
                                    onClick={() => updateIndex(index)}
                                    sx={{
                                        '&:hover': {
                                        transform: "scale(1.05)",
                                        cursor: 'pointer',
                                        },
                                        backgroundColor: selectedIndex === index ? "#D4E2F1" : "#FFFFFF"
                                    }}
                                >
                                    <TableCell>{item.bundleName}</TableCell>
                                    <TableCell>{item.assetCount}</TableCell>
                                    <TableCell>{item.score}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </MDBox>
    );
}

export default BundleList;